import React from 'react';
import './Header.css';

const Header = () => {
    return (
        <div className="header">
            <h1>Food House</h1>
            <h4>This is a food site<br />
                Our Monthly Targeted Sells 20k
            </h4>
            <p>Hey!! Greetings From Owner..Thank you to visit my site.Here You can find your wanted food with reasonable price..</p>
        </div>
    );
};

export default Header;